import { render, staticRenderFns } from "./GroupsSelect.vue?vue&type=template&id=30d7d654"
import script from "./GroupsSelect.vue?vue&type=script&lang=js"
export * from "./GroupsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports